import {
  BRANCH_LIST,
  BRANCH_CREATE,
  BRANCH_DETAILS,
  BRANCH_UPDATE,
  BRANCH_MEMBERS,
  REMOVE_MEMBER_FROM_BRANCH,
} from '../constants/action-types'
import { BranchData } from '../Actions'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { ActionTypes } from '../action'

const initialState: BranchData = {
  isBranchListLoading: false,
  branchList: { count: 0, results: [] },
  createBranchData: Object,
  branchDetails: Object,
  branchMembers: [],
}

const branchDataReducer = persistReducer(
  { storage, key: 'basecode-demo', whitelist: ['user'] },
  (state: BranchData = initialState, action: ActionTypes) => {
    switch (action.type) {
      case BRANCH_LIST.BRANCH_LIST_INITIALIZATION:
        return {
          ...state,
          isBranchListLoading: true,
        }
      case BRANCH_LIST.BRANCH_LIST_ERROR:
        return {
          ...state,
          isBranchListLoading: false,
        }
      case BRANCH_LIST.BRANCH_LIST_SUCCESS:
        // eslint-disable-next-line no-case-declarations
        const payload = action?.payload as any
        return {
          ...state,
          isBranchListLoading: false,
          branchList: payload,
        }
      // Branch Members
      case BRANCH_MEMBERS.BRANCH_MEMBERS_INITIALIZATION:
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isBranchListLoading: true,
        }

      case BRANCH_MEMBERS.BRANCH_MEMBERS_SUCCESS: {
        const members: any = action.payload
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isBranchListLoading: false,
          branchMembers: members,
        }
      }

      case BRANCH_MEMBERS.BRANCH_MEMBERS_ERROR:
        return {
          ...state,
          ...action.payload,
          errorMessage: action.payload,
          isBranchListLoading: false,
        }
      //create branch
      case BRANCH_CREATE.BRANCH_CREATE_INITIALIZATION:
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isBranchListLoading: true,
        }

      case BRANCH_CREATE.BRANCH_CREATE_SUCCESS:
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isBranchListLoading: false,
        }

      case BRANCH_CREATE.BRANCH_CREATE_ERROR:
        return {
          ...state,
          ...action.payload,
          errorMessage: action.payload,
          isBranchListLoading: false,
        }

      //Details BRANCH
      case BRANCH_DETAILS.BRANCH_DETAILS_INITIALIZATION:
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isBranchListLoading: false,
        }
      case BRANCH_DETAILS.BRANCH_DETAILS_SUCCESS: {
        const branch: any = action.payload
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isBranchListLoading: false,
          branchDetails: branch,
        }
      }

      case BRANCH_DETAILS.BRANCH_DETAILS_ERROR:
        return {
          ...state,
          ...action.payload,
          errorMessage: action.payload,
          isBranchListLoading: false,
        }
      //Update BRANCH
      case BRANCH_UPDATE.BRANCH_UPDATE_INITIALIZATION:
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isBranchListLoading: true,
        }
      case BRANCH_UPDATE.BRANCH_UPDATE_SUCCESS:
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isBranchListLoading: false,
        }

      case BRANCH_UPDATE.BRANCH_UPDATE_ERROR:
        return {
          ...state,
          ...action.payload,
          errorMessage: action.payload,
          isBranchListLoading: false,
        }
      // Remove member from branch
      case REMOVE_MEMBER_FROM_BRANCH.REMOVE_MEMBER_FROM_BRANCH_INITIALIZATION:
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isBranchListLoading: true,
        }

      case REMOVE_MEMBER_FROM_BRANCH.REMOVE_MEMBER_FROM_BRANCH_SUCCESS:
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isBranchListLoading: false,
        }

      case REMOVE_MEMBER_FROM_BRANCH.REMOVE_MEMBER_FROM_BRANCH_ERROR:
        return {
          ...state,
          ...action.payload,
          errorMessage: action.payload,
          isBranchListLoading: false,
        }
      default:
        return state
    }
  }
)

export default branchDataReducer
